import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./home.css";
import heroImage from "../image/banerImage.jpeg";
import { Award, Users, Clock, Star } from "lucide-react";

import p1 from "../image/p1.jpeg";
import p2 from "../image/p2.jpeg";
import p3 from "../image/p3.jpeg";
import p4 from "../image/p4.jpeg";
import p5 from "../image/p5.jpeg";
import p6 from "../image/p6.jpeg";

function Home() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const statsData = [
    { label: t("stat_projects"), value: 500, suffix: "+" },
    { label: t("stat_years"), value: 12, suffix: "+" },
    { label: t("stat_clients"), value: 98, suffix: "%" },
  ];

  const [stats, setStats] = useState(statsData.map(() => 0));

  useEffect(() => {
    const duration = 2000;
    const fps = 60;
    const totalFrames = Math.round((duration / 1000) * fps);

    const intervals = statsData.map((stat, idx) => {
      let frame = 0;
      return setInterval(() => {
        frame++;
        setStats((prev) => {
          const updated = [...prev];
          const progress = frame / totalFrames;
          updated[idx] = Math.round(stat.value * progress);
          return updated;
        });
        if (frame >= totalFrames) clearInterval(intervals[idx]);
      }, 1000 / fps);
    });

    return () => intervals.forEach(clearInterval);
  }, []);

  return (
    <div className="home-container">
      <section className="hero-section">
        <div className="hero-left">
          <h1 className="hero-title">{t("hero_title")}</h1>
          <p className="hero-text">{t("hero_text")}</p>

          <div className="hero-buttons">
            <button className="btn-primary" onClick={() => navigate("/our-work")}>
              {t("btn_explore")}
            </button>
            <button className="btn-secondary" onClick={() => navigate("/contact")}>
              {t("btn_contact")}
            </button>
          </div>

          <div className="stats">
            {statsData.map((stat, index) => (
              <div className="stat-box" key={index}>
                <h2>{stats[index]}{stat.suffix}</h2>
                <p>{stat.label}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="hero-right">
          <img src={heroImage} className="hero-img" alt="Interior" />
        </div>
      </section>

      <section className="services-section">
        <h2 className="section-title">{t("services_title")}</h2>
        <p className="section-description">{t("services_description")}</p>

        <div className="services-container">
          {["1", "2", "3"].map((num) => (
            <div className="service-item" key={num}>
              <div className="service-icon">
                <i className={`fas fa-${num === "1" ? "th-large" : num === "2" ? "home" : "shield-alt"}`}></i>
              </div>
              <h3>{t(`service${num}_title`)}</h3>
              <p>{t(`service${num}_text`)}</p>
              <ul>
                {[1, 2, 3].map((i) => <li key={i}>{t(`service${num}_li${i}`)}</li>)}
              </ul>
            </div>
          ))}
        </div>
      </section>

      <section className="projects-section">
        <h2 className="projects-title">{t("projects_title")}</h2>
        <p className="projects-subtitle">{t("projects_subtitle")}</p>

        <div className="projects-grid">
          {[p1, p2, p3, p4, p5, p6].map((img, index) => (
            <div key={index} className="project-card" onClick={() => navigate("/our-work")}>
              <img src={img} alt="Project" />
              <div className="project-info">
                <span>{t("project_label")}</span>
                <h3>{t("project_title")}</h3>
              </div>
            </div>
          ))}
        </div>

        <div className="view-projects" onClick={() => navigate("/our-work")}>
          {t("view_all")} <i className="fas fa-arrow-right"></i>
        </div>
      </section>

      <section className="why-section">
        <h2 className="why-title">{t("why_title")}</h2>
        <p className="why-subtitle">{t("why_subtitle")}</p>

        <div className="why-container">
          {[Award, Users, Clock, Star].map((Icon, idx) => (
            <div className="why-item" key={idx}>
              <div className="why-icon"><Icon size={32} strokeWidth={1.7} color="white" /></div>
              <h3>{t(`why${idx + 1}_title`)}</h3>
              <p>{t(`why${idx + 1}_text`)}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="testimonials-section">
        <h2 className="testimonials-title">{t("testimonials_title")}</h2>
        <p className="testimonials-subtitle">{t("testimonials_subtitle")}</p>

        <div className="testimonials-container">
          {[1,2,3].map((i) => (
            <div className="testimonial-card" key={i}>
              <div className="stars">★★★★★</div>
              <p className="testimonial-text">{t(`test${i}_text`)}</p>
              <div className="testimonial-divider"></div>
              <h4 className="testimonial-name">{t(`test${i}_name`)}</h4>
              <span className="testimonial-role">{t(`test${i}_role`)}</span>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}

export default Home;
